/*
 * พฤติกรรมผู้ใช้เว็บหน้าบ้าน (ข้อมูลจาก analytics_event / analytics_session)
 *
 * แยกออกมาจากกลุ่ม Logs เพราะคนละเรื่องกัน — Logs คือ log ของระบบไว้ไล่ปัญหา
 * ส่วนนี้คือข้อมูลไว้ตัดสินใจเรื่องการตลาดและการยิง ads
 */
export default [
  {
    header: 'Analytics',
    resource: 'MailLog',
    action: 'read',
  },
  {
    title: 'ภาพรวม',
    icon: 'BarChart2Icon',
    route: 'analytics-report',
    resource: 'MailLog',
    action: 'read',
  },
  {
    // คำค้นไหน -> ผู้ใช้คลิกดูห้องไหน -> ติดต่อหรือไม่
    title: 'คำค้น → ห้องที่คลิก',
    icon: 'SearchIcon',
    route: 'analytics-search-journey',
    resource: 'MailLog',
    action: 'read',
  },
  {
    // เข้ามาแล้วเดินต่อไปหน้าไหน — ลำดับของหน้า ไม่ใช่แค่ยอดเข้าชม
    title: 'เส้นทางผู้ใช้',
    icon: 'GitMergeIcon',
    route: 'analytics-user-path',
    resource: 'MailLog',
    action: 'read',
  },
  {
    // ห้องนี้คนเข้ามาจากไหนบ้าง (ผลค้นหา / แนะนำ / ใกล้เคียง / เข้าตรง)
    title: 'ห้อง → ทางเข้า',
    icon: 'HomeIcon',
    route: 'analytics-property-journey',
    resource: 'MailLog',
    action: 'read',
  },
]
